import { useLoaderData } from "react-router-dom";
import { Content } from "antd/es/layout/layout";
import { Typography } from "antd";
import { MessageDetailsPageLoaderType } from "./loaders";
const { Title, Text, Paragraph } = Typography;

export const MessageDetailsPage = () => {
  const loaderData = useLoaderData() as unknown as MessageDetailsPageLoaderType;

  return (
    <Content className="service-request-detail">
      <Title className="service-request-detail-title" level={1}>
        Message
      </Title>
      <Paragraph className="service-request-detail-item">
        <Text strong>Type: </Text> {loaderData.message.title}
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>Title: </Text> {loaderData.message.messageTitle}
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>Sender: </Text>
        {loaderData.message.senderName}
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>Sent At: </Text> {loaderData.message.createdAt}
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>Content: </Text> {loaderData.message.content}
      </Paragraph>
    </Content>
  );
};
